import { Link } from 'react-router-dom';
import styles from '@styles/components/Button.module.css';

interface Props {
  variant?: 'default' | 'highlighted';
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  type?: 'button' | 'submit';
  disabled?: boolean;
}

export default function Button({ variant = 'default', children, href, onClick, type = 'button', disabled }: Props) {
  const className = `${styles.btn} ${variant === 'highlighted' ? styles.highlighted : ''}`;

  if (href) {
    return <Link to={href} className={className}>{children}</Link>;
  }

  return <button type={type} className={className} onClick={onClick} disabled={disabled}>{children}</button>;
}
